var exports = {
  "Y": "xaee3c4fa--bb989c--modal-content",
};

module.exports = exports;
